/**
 * Function-name -> FlowRunner flow-id map (scanned by QUAL-FLOW-MAP-SYNC-001). Keys are exactly the names the assistant
 * runner can dispatch; the apps/federa function-card execute route resolves the same keys from persisted rows.
 *
 * VALUES MUST STAY BARE STRING LITERALS -- never re-route them through a flow-id alias const. Two live consumers parse this
 * literal block as TEXT and accept a quoted value only, so a `<CONST>.<KEY>` member access silently disables them rather than
 * failing loudly: `partitionMapBodyByValue` (the delete-flow sweep node) and QUAL-FLOW-MAP-SYNC-001's value validation. Such
 * an alias also fires QUAL-FLOW-NAME-ALIAS-CATALOG-BAN-001; the `satisfies Record<string, FlowName>` pin is compatible because `satisfies` does not rewrite the literal.
 */

import type { FlowName } from '@federa/types/flows-flow-name.generated';

export const FUNCTION_TO_FLOW_MAP: Record<string, string> = {
	fetch_account_details: 'user-fetch-account-details',
	fetch_user_ledger_transactions: 'get-user-ledger-transactions',
	add_licence: 'function-card-add-licence',
	update_licence: 'function-card-update-licence',
	fetch_user_licenses: 'license-fetch-all',
	vector_search: 'agent-vector-search',
	// The federa-ai-tools door's property search: the same flow, its corpus pinned by FUNCTION_FIXED_ARGS.
	search_properties: 'agent-vector-search',
	call_endpoint: 'agent-call-endpoint',
	// In-call verification (2026-09-29): the desk's text-code challenge, started and checked by Alex on a phone call.
	send_verification_code: 'agent-call-verification-send',
	check_verification_code: 'agent-call-verification-check',
	fetch_property: 'assistant-property-retrieval-fetch',
	fetch_user_refundable_transactions: 'get-user-refundable-transactions',
	initiate_refund: 'function-card-initiate-refund',
	buy_transaction: 'function-card-buy-transaction',
	new_user: 'function-card-new-user',
	contact_add: 'function-card-contact-add',
	create_conversation: 'conversation-create-chat',
	handle_conversation_create_v2_chat: 'conversation-create-chat',
	create_issue: 'issue-create',
	activity_summary: 'activity-summary',
} satisfies Record<string, FlowName>;
